var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalysisOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7253_85763",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 13,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5127 9.33333H4.82039V2H6.5127V9.33333ZM3.69219 9.33333H1.99988V5.66667H3.69219V9.33333ZM7.6409 4.25641V9.33333H9.33321V4.25641H7.6409ZM10 7.39455C11.0836 7.5676 11.9117 8.50652 11.9117 9.63884C11.9117 10.2551 11.6664 10.814 11.2682 11.2234C11.2602 11.2301 11.2524 11.2372 11.2448 11.2448C11.2372 11.2524 11.2301 11.2602 11.2234 11.2683C10.814 11.6664 10.255 11.9117 9.63882 11.9117C8.50644 11.9117 7.56748 11.0836 7.39451 9.9999H6.68835C6.86653 11.4711 8.11955 12.611 9.63881 12.611C10.3336 12.611 10.9726 12.3726 11.4787 11.9732L13.0631 13.5576C13.1996 13.6941 13.421 13.6941 13.5576 13.5576C13.6941 13.421 13.6941 13.1996 13.5576 13.0631L11.9732 11.4787C12.3726 10.9726 12.611 10.3336 12.611 9.63883C12.611 8.11962 11.4712 6.86664 10 6.6884V7.39455Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7253_85763)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#828282"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysisOutlined);
export default __webpack_public_path__ + "static/media/Analysis_outlined.7ddebccd.svg";
export { ForwardRef as ReactComponent };